import { Grid, Typography, Box, Slider } from "@material-ui/core";

import { tableCellRender } from "../../util/tableUtils";
import { DisplayRowField } from "./DisplayRowField";
import { t } from "i18next";

export const defaultMarks = [
  {
    value: 1,
    label: "1",
  },
  {
    value: 3,
    label: "3",
  },
];

const calcRiskIndex = (riskIndexValue) => {
  if (riskIndexValue === 1) return t("levels.veryLow");
  if (riskIndexValue === 1.25) return t("levels.veryLow");
  if (riskIndexValue === 1.5) return t("levels.relativelyLow");
  if (riskIndexValue === 1.75) return t("levels.relativelyLow");
  if (riskIndexValue === 2) return t("levels.medium_a");
  if (riskIndexValue === 2.25) return t("levels.medium_a");
  if (riskIndexValue === 2.5) return t("levels.relativelyHigh");
  if (riskIndexValue === 2.75) return t("levels.relativelyHigh");
  if (riskIndexValue === 3) return t("levels.veryHigh");
  return "Not available";
};

export const gridForHazard = (t, label, value, allocation) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <Typography variant="body2" gutterBottom>
          {label}:
        </Typography>
      </Grid>

      <Grid item xs={9}>
        <DisplayRowField label={t("climateIndex.score")} value={calcRiskIndex(value)} />

        <DisplayRowField label={t("climateIndex.value")} value={value} />

        <DisplayRowField label={t("climateIndex.allocation")} value={allocation} />
      </Grid>
    </Grid>
  );
};

export const gridForComputedIndex = (t, selectedProperties, riskScore, aniaRiskSliderMarks, title) => {
  return (
    <>
      <DisplayRowField label={t("agriculture.municipality")} value={selectedProperties?.COMUNE} />
      <DisplayRowField label={t("agriculture.province")} value={selectedProperties?.COD_PROV} />
      <DisplayRowField label={t("agriculture.region")} value={selectedProperties?.COD_REG} />
      <Typography>
        <Box fontWeight="fontWeightBold" mt={2} mb={2}>
          {title} : {riskScore}
        </Box>
      </Typography>
      <Box mt={1}>
        <Typography id="ania-risk-index" variant="body2" gutterBottom>
          {t("climateIndex.riskIndex")}:
        </Typography>
        <Slider
          value={riskScore}
          aria-labelledby="ania-risk-index"
          marks={aniaRiskSliderMarks}
          min={1}
          max={3}
          disabled
        />

        <Typography variant="caption" gutterBottom>
          {t("climateIndex.theRiskIndexIs")}
          <strong> {calcRiskIndex(riskScore)} </strong>
          {t("climateIndex.forCommune")}
          <strong> {selectedProperties?.COMUNE} </strong> {t("climateIndex.comparedTheRestOfItaly")}
        </Typography>
      </Box>
      <Typography>
        <Box fontWeight="fontWeightBold" mt={2} mb={2}>
          {t("climateIndex.hazardTypeRiskRatings")}:
        </Box>
      </Typography>
    </>
  );
};

const convert5Levelsto3Levels = (severityIndex) => {
  // Convert [1..5] in geojson to [1..3] on platform
  return severityIndex && (severityIndex - 1) / 2 + 1;
};

export const handleSelectedProperties = (
  propertyName,
  selectedProp,
  setRiskScoreValue,
  setAniaRiskSliderMarks,
  setSelectedProperties,
) => {
  let currRiskIndexValue = selectedProp ? selectedProp[propertyName] : null;
  if (currRiskIndexValue) {
    currRiskIndexValue = convert5Levelsto3Levels(currRiskIndexValue);

    setRiskScoreValue(currRiskIndexValue);
    // avoid having two items with the same value (key)
    if (currRiskIndexValue === 2) {
      setAniaRiskSliderMarks([
        ...defaultMarks,
        {
          value: currRiskIndexValue,
          label: tableCellRender(currRiskIndexValue),
        },
      ]);
    } else {
      setAniaRiskSliderMarks(defaultMarks);
    }
  }
  setSelectedProperties(selectedProp);
};
